// // import React from 'react';
// // import bannerImage from '../img/banner/banner.jpg'; // Adjust the path according to your project structure

// // const MainBanner = () => {
// //   return (
// //     <div className="hero-area overly-style-1 opacity-point-4" style={{ height: '650px', position: 'relative' }}>
// //       {/* Image that covers the full screen */}
// //       <img 
// //         className="banner-image" 
// //         src={bannerImage} 
// //         alt="Main Banner" 
// //         style={{ 
// //           // position: 'absolute',
// //           top: 0,
// //           left: 0,
// //           width: '100%',
// //           height: '100%',
// //           objectFit: 'cover' // Ensures the image covers the entire area without distortion
// //         }} 
// //       />
// //  <div className="hero-content-1 hero-content-position" style={{ color: '#fff',  zIndex: 1 }}>
// //   <h1 style={{ color: "#fff",  fontFamily: "Urbanist, serif", fontWeight: 700,letterSpacing: "4px"   }}>
// //     Welcome To <span style={{fontFamily: 'Raqupine Regular' }}> MODULEX INTERIORS </span>
// //   </h1>
// // </div>
// //     </div>
// //   );
// // }

// // export default MainBanner;

// // import React from 'react';
// // import bannerVideo from '../img/banner/winter-2024.mp4'; // Replace with the correct path to your video file

// // const MainBanner = () => {
// //   return (
// //     <div
// //       className="hero-area overly-style-1 opacity-point-4"
// //       style={{ height: '800px',width:'100%', position: 'relative', overflow: 'hidden' }}
// //     >

// //       {/* Video that covers the full screen */}
// //       <video
// //         className="banner-video"
// //         src={bannerVideo}
// //         autoPlay
// //         loop
// //         muted
// //         playsInline
// //         style={{
// //            position: 'absolute',
// //            top: 0,
// //            left: 0,
// //           // width: '100%',
// //           // height: 'auto',
// //            objectFit: 'cover', // Ensures the video covers the entire area without distortion
// //            zIndex: -1,
          
// //           // Keeps the video behind the content
// //         }}
// //       ></video>

// //       {/* Overlay Content */}
// //       <div
// //         className="hero-content-1 hero-content-position"
// //         style={{ color: '#fff', zIndex: 1, textAlign: 'center' }}
// //       >
// //         <h1
// //           style={{
// //             color: '#fff',
// //             fontFamily: 'Urbanist, serif',
// //             fontWeight: 700,
// //             letterSpacing: '4px',
// //           }}
// //         >
// //           {' '}
// //           <span style={{ fontFamily: 'Raqupine Regular' }}></span>
// //         </h1>
// //       </div>
// //     </div>
// //   );
// // };

// // export default MainBanner;
// import React from 'react';
// import bannerVideo from '../img/banner/135141-761273478_medium.mp4'; // Replace with the correct path to your video file

// const MainBanner = () => {
//   return (
//     <div
//       className="hero-area overly-style-1 opacity-point-4"
//       style={{
//         height: '700px',
//         width: '100%',
//         position: 'relative',
//         overflow: 'hidden',
//       }}
//     >
//       {/* Video that covers the full screen */}
//       <video
//         className="banner-video"
//         src={bannerVideo}
//         autoPlay
//         loop
//         muted
//         playsInline
//         style={{
//           position: 'absolute',
//           top: 0,
//           left: 0,
//           width: '100%',
//           height: '100%',
//           objectFit: 'cover', // Ensures the video covers the entire area without distortion
//           zIndex: -1, // Keeps the video behind the content
//         }}
//       ></video>

//       {/* Overlay Content */}
//       <div
//         className="hero-content-1 hero-content-position"
//         style={{
//           color: '#fff',
//           zIndex: 1,
//           position: 'absolute',
//           top: '50%',
//           left: '50%',
//           transform: 'translate(-50%, -50%)',
//           textAlign: 'center',
//           width: '100%', // Ensures the text is centered properly
//         }}
//       >
//         <h1
//           style={{
//             color: '#fff',
//             fontSize:'48PX',
//             fontFamily: 'Raqupine Regular',
//             fontWeight: 700,
//             letterSpacing: '4px',
//           }}
//         >
//           {' '}
       
//         </h1>
//       </div>
//     </div>
//   );
// };

// export default MainBanner;




// import React from 'react';
// import bannerImage from '../img/banner/01.jpg'; // Correct the path based on your folder structure

// const MainBanner = () => {
//   return (
//     <div
//       className="hero-area overly-style-1 opacity-point-4"
//       style={{
//         height: '700px',
//         width: '100%',
//         position: 'relative',
//         overflow: 'hidden',
//       }}
//     >
//       {/* Image Banner */}
//       <img
//         className="banner-image"
//         src={bannerImage}
//         alt="Main Banner"
//         style={{
//           position: 'absolute',
//           top: 0,
//           left: 0,
//           width: '100%',
//           height: '100%',
//           objectFit: 'cover', // Ensures the image covers the entire area without distortion
//           zIndex: -1, // Keeps the image behind the content
//         }}
//       />

//       {/* Overlay Content */}
//       <div
//         className="hero-content-1 hero-content-position"
//         style={{
//           color: '#fff',
//           zIndex: 1,
//           position: 'absolute',
//           top: '50%',
//           left: '50%',
//           transform: 'translate(-50%, -50%)',
//           textAlign: 'center',
//           width: '100%', // Ensures the text is centered properly
//         }}
//       >
//         <h1
//           style={{
//             color: '#fff',
//             fontSize: '48px',
//             fontFamily: 'Raqupine Regular',
//             fontWeight: 700,
//             letterSpacing: '4px',
//           }}
//         >
//           <span style={{ fontFamily: 'Urbanist, serif' }}>MODULEX INTERIORS</span>
//         </h1>
//       </div>
//     </div>
//   );
// };

// export default MainBanner;




// import React, { useState } from "react";
// import bannerImage from "../img/banner/01.jpg"; // Update the path if needed


// const BookingSection = () => {
//   const [checkIn, setCheckIn] = useState(null);
//   const [checkOut, setCheckOut] = useState(null);
//   const [adults, setAdults] = useState(1);
//   const [children, setChildren] = useState(0);
//   const [rooms, setRooms] = useState(1);

//   return (
//     <div>
//       {/* Parallax Header */}
//       <section className="parallax-header">
//         <div className="overlay" style={{ fontFamily:'Raqupine Regular',fontSize:'15px'}}>
//           {/* <h5>Rixos Luxury Hotel</h5> */}
//           <h1 className="banner-text">Enjoy a Luxury Experience</h1>
//         </div>


//         <div className="booking-wrapper">
//         <form className="booking-form">
//           <div className="form-group">
//             <label>Check in</label>
//             <input
//               type="date"
//               value={checkIn}
//               onChange={(e) => setCheckIn(e.target.value)}
//             />
//           </div>

//           <div className="form-group">
//             <label>Check out</label>
//             <input
//               type="date"
//               value={checkOut}
//               onChange={(e) => setCheckOut(e.target.value)}
//             />
//           </div>

//           <div className="form-group">
//             <label>Adults</label>
//             <select value={adults} onChange={(e) => setAdults(e.target.value)}>
//               {[1, 2, 3, 4].map((num) => (
//                 <option key={num} value={num}>
//                   {num} {num === 1 ? "Adult" : "Adults"}
//                 </option>
//               ))}
//             </select>
//           </div>

//           <div className="form-group">
//             <label>Children</label>
//             <select
//               value={children}
//               onChange={(e) => setChildren(e.target.value)}
//             >
//               {[0, 1, 2, 3, 4].map((num) => (
//                 <option key={num} value={num}>
//                   {num} {num === 1 ? "Child" : "Children"}
//                 </option>
//               ))}
//             </select>
//           </div>

//           <div className="form-group">
//             <label>Rooms</label>
//             <select value={rooms} onChange={(e) => setRooms(e.target.value)}>
//               {[1, 2, 3, 4].map((num) => (
//                 <option key={num} value={num}>
//                   {num} {num === 1 ? "Room" : "Rooms"}
//                 </option>
//               ))}
//             </select>
//           </div>

//           <button type="submit" className="btn-submit">
//           Enquiry Now
//           </button>
//         </form>
//       </div>
//       </section>

//       {/* Booking Form */}
     

//       {/* Internal CSS */}
//       <style jsx>{`
//         .parallax-header {
//           background: url(${bannerImage}) no-repeat center center / cover;
//           height: 650px;
//           display: flex;
//           justify-content: center;
//           align-items: center;
//           position: relative;
//           text-align: center;
//         }

//         .overlay {
//           background: rgba(0, 0, 0, 0.5);
//           padding: 20px;
//           color: #fff;
//           width: 100%;
//         }
//            @keyframes textAppear {
//   0% {
//     opacity: 0;
//     transform: translateY(100px);
//   }
//   100% {
//     opacity: 1;
//     transform: translateY(0);
   
//   }
// }
//   .overlay {
//           background: rgba(0, 0, 0, 0.5);
//           padding: 20px;
//           color: #fff;
//           width: 100%;
//         }

//          .booking-wrapper {
//           display: flex;
//           justify-content: center;
//           position: relative;
//           margin-top: 20px;
//         }

//         .booking-form {
//           display: flex;
//           background: rgba(255, 255, 255, 0.2);
//           padding: 15px 15px 0px 15px;
//           border-radius: 5px;
//           box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
//           gap: 15px;
//           backdrop-filter: blur(10px);
//            margin-top: 350px;
//         }

//         .form-group {
//           display: flex;
//           flex-direction: column;
//         }

//         .form-group label {
//           font-size: 18px;
//           // font-weight: bold;
//          font-family: roboto;
//          color: #ff9503;
//         }

//         .form-group input,
//         .form-group select {
//           padding: 8px;
//           border: 1px solid #ccc;
//           border-radius: 5px;
//           margin-top: 5px;
//         }

//         .btn-submit {
//           background: #ff5a5f;
//           color: white;
//           border: none;
//           padding: 10px 15px;
//           cursor: pointer;
//           border-radius: 30px;
//           transition: 0.3s;
//           width:131px;
//           height:50px;
//           margin-top: 25px;

//         }
//           .banner-text {
//   font-size: 25px;
//   font-weight: bold;
//   color: white;
//   text-align: center;
//   position: absolute;
//   animation: textAppear 1.5s ease-in-out forwards;
// }

//         .btn-submit:hover {
//           background: #d4393e;
//         }

//        @media (max-width: 768px) {
//   .booking-form {
//      display: none;
//   }
// }
//       `}</style>
//     </div>
//   );
// };

// export default BookingSection;




// import React from 'react';

// const DhanturiGroup = () => {
//   return (
//     <>
//       <style>{`
//         body {
//           margin: 0;
//           padding: 0;
//         }

//         .main-container {
//           background: radial-gradient(circle, #001a33, #000c1a);
//           font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
//           color: #fff;
//           text-align: center;
//           padding: 20px;
//         }

//         .logo-container img {
//           max-width: 200px;
//           width: 100%;
//         }

//         .title-text {
//           font-size: 32px;
//           font-weight: bold;
//           color: #f4c067;
//         }

//         .subtitle-text {
//           font-size: 18px;
//           color: #f4c067;
//           margin-bottom: 30px;
//         }

//         .cards-container {
//           display: flex;
//           justify-content: center;
//           flex-wrap: wrap;
//           gap: 20px;
//           padding: 20px 0;
//         }

//         .cardss {
//           background: #fff;
//           border-radius: 20px;
//           width: 270px;
//           height: 350px;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           padding: 10px;
//         }

//         .card img {
//           max-width: 100%;
//           max-height: 100%;
//           object-fit: contain;
//         }

//         @media (max-width: 768px) {
//           .title-text {
//             font-size: 24px;
//           }

//           .subtitle-text {
//             font-size: 16px;
//           }

//           .card {
//             width: 45%;
//             height: 150px;
//           }
//         }

//         @media (max-width: 480px) {
//           .card {
//             width: 100%;
//             height: 140px;
//           }
//         }
//       `}</style>

//       <div className="main-container" style={{marginTop:'96px',height:'650px'}}>
//         <div className="logo-container">
//           <img src="/images/image.png" alt="Dhanturi Group Logo" />
//         </div>

//         <div className="title-text">SHARAN INN</div>
//         <div className="subtitle-text">GROUP</div>

//         <div className="cards-container">
//           <div className="cardss">
//             <img src="/images/logo1.png" alt="Group of Hotels" />
//           </div>
//           <div className="cardss">
//             <img src="/images/logo2.png" alt="Rveez Pharma" />
//           </div>
//           <div className="cardss">
//             <img src="/images/logo3.png" alt="Dhanturi Hospitals" />
//           </div>
//           <div className="cardss">
//             <img src="/images/logo4.png" alt="Aircare" />
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default DhanturiGroup;






// import React from 'react';
// import logoMain from '../img/aaaservices/sicon.png';
// import logo1 from '../img/aaaservices/hotelw.jpg';
// import logo2 from '../img/aaaservices/hotelw.jpg';
// import logo3 from '../img/aaaservices/hotelw.jpg';
// import logo4 from '../img/aaaservices/hotelw.jpg';

// import { FaBed, FaUtensils, FaLandmark, FaPhoneAlt, FaStreetView, FaMapMarkerAlt } from 'react-icons/fa';

// const open360View = () => {
//   window.open('https://your360viewlink.com', '_blank');
// };

// const openGoogleMap = () => {
//   window.open('https://maps.google.com/?q=your+location', '_blank');
// };

// const callNow = () => {
//   window.location.href = 'tel:+1234567890';
// };

// const DhanturiGroup = () => {
//   const cardData = [
//     { img: logo1, btnText: 'Book Now', location: 'Hyderabad' },
//     { img: logo2, btnText: 'Book Room', location: 'Bengaluru' },
//     { img: logo3, btnText: 'Reserve Now', location: 'Chennai' },
//     { img: logo4, btnText: 'Book Suite', location: 'Mumbai' },
//   ];

//   return (
//     <>
//       <style>{`
//         .main-container {
//           background: radial-gradient(circle, #001a33, #000c1a);
//           font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
//           color: #fff;
//           text-align: center;
//           padding: 20px;
//         }

//         .logo-container img {
//           max-width: 200px;
//           width: 100%;
//         }

//         .title-text {
//           font-size: 32px;
//           font-weight: bold;
//           color: #f4c067;
//         }

//         .subtitle-text {
//           font-size: 18px;
//           color: #f4c067;
//           margin-bottom: 30px;
//         }

//         .cards-container {
//           display: flex;
//           justify-content: center;
//           flex-wrap: wrap;
//           gap: 20px;
//           padding: 20px 0;
//         }

//         .cardss {
//           background: #fff;
//           border-radius: 20px;
//           width: 270px;
//           display: flex;
//           flex-direction: column;
//           align-items: center;
//           overflow: hidden;
//           padding-bottom: 20px;
//           height: 393px;
//           position: relative;
//         }

//         .image-container {
//           position: relative;
//           width: 100%;
//           height: 200px;
//         }

//         .image-container img {
//           width: 100%;
//           height: 100%;
//           object-fit: cover;
//         }

//         .location-overlay {
//           position: absolute;
//           top: 141px;
//           left: 76px;
//           background: rgba(0, 26, 51, 0.7);
//           color: #f4c067;
//           padding: 6px 12px;
//           border-radius: 10px;
//           font-size: 14px;
//           display: flex;
//           align-items: center;
//           font-weight: bold;
//           z-index: 1;
//         }

//         .icon-row {
//           display: flex;
//           justify-content: center;
//           gap: 15px;
//           margin: 10px 0;
//         }

//         .circle-icon {
//           width: 50px;
//           height: 50px;
//           border-radius: 50%;
//           background-color: #001a33;
//           color: #f4c067;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           font-size: 20px;
//           cursor: pointer;
//           transition: background 0.3s;
//         }

//         .circle-icon:hover {
//           background-color: #f4c067;
//           color: #001a33;
//         }

//         .card-button {
//           margin-top: 10px;
//           padding: 8px 16px;
//           background-color: #001a33;
//           color: #f4c067;
//           border: none;
//           border-radius: 10px;
//           font-weight: bold;
//           cursor: pointer;
//           transition: all 0.3s;
//         }

//         .card-button:hover {
//           background-color: #f4c067;
//           color: #001a33;
//         }

//         .main-button {
//           margin-top: 30px;
//           padding: 12px 30px;
//           background-color: #f4c067;
//           color: #001a33;
//           border: none;
//           border-radius: 30px;
//           font-size: 16px;
//           font-weight: bold;
//           cursor: pointer;
//           transition: all 0.3s;
//         }

//         .main-button:hover {
//           background-color: #fff;
//           color: #000c1a;
//         }

//         @media (max-width: 768px) {
//           .title-text {
//             font-size: 24px;
//           }

//           .subtitle-text {
//             font-size: 16px;
//           }

//           .cardss {
//             width: 100%;
//           }
//         }
//       `}</style>

//       <div className="main-container" style={{ }}>
//         <div className="logo-container">
//           <img src={logoMain} alt="Dhanturi Group Logo" />
//         </div>

//         <div className="title-text">SHARAN INN</div>
//         <div className="subtitle-text">GROUP</div>

//         <div className="cards-container">
//           {cardData.map((card, index) => (
//             <div className="cardss" key={index}>
//               <div className="image-container">
//                 <img src={card.img} alt={`Card ${index + 1}`} />
//                 <div className="location-overlay">
//                   <FaMapMarkerAlt style={{ marginRight: '6px' }} />
//                   {card.location}
//                 </div>
//               </div>

//               {/* First row: Room, Restaurant, Banquet */}
//               <div className="icon-coloumn" >
//                 <div className="circle-icon" title="Room">
//                   <FaBed />
//                 </div>
//                 <div className="circle-icon" title="Restaurant">
//                   <FaUtensils />
//                 </div>
//                 <div className="circle-icon" title="Banquet Hall">
//                   <FaLandmark />
//                 </div>
//               </div>

//               {/* Second row: Call, 360, Location */}
//               {/* <div className="icon-row">
//                 <div className="circle-icon" onClick={callNow} title="Call Now">
//                   <FaPhoneAlt />
//                 </div>
//                 <div className="circle-icon" onClick={open360View} title="360° View">
//                   <FaStreetView />
//                 </div>
//                 <div className="circle-icon" onClick={openGoogleMap} title="Location">
//                   <FaMapMarkerAlt />
//                 </div>
//               </div> */}

//               <button className="card-button">{card.btnText}</button>
//             </div>
//           ))}
//         </div>

//         {/* Optional main button */}
//         {/* <button className="main-button">Explore All Businesses</button> */}
//       </div>
//     </>
//   );
// };

// export default DhanturiGroup;



// import React from "react";
// import { FaBed, FaUtensils, FaLandmark } from "react-icons/fa";
//  import logoMain from '../img/aaaservices/S LOGO PNG-02-01.png';
// // ✅ Import all 4 images
// import hotelRoomImg1 from "../img/aaaservices/hotelw.jpg";
// import hotelRoomImg2 from "../img/aaaservices/hotelw.jpg";
// import hotelRoomImg3 from "../img/aaaservices/hotelw.jpg";
// import hotelRoomImg4 from "../img/aaaservices/hotelw.jpg";

// const cardData = [
//   {
//     image: hotelRoomImg1,
//     location: "City Center, Delhi",
//   },
//   {
//     image: hotelRoomImg2,
//     location: "Beach View, Goa",
//   },
//   {
//     image: hotelRoomImg3,
//     location: "Hilltop, Shimla",
//   },
//   {
//     image: hotelRoomImg4,
//     location: "Lakefront, Udaipur",
//   },
// ];

// const HotelFacilities = () => {
//   return (
//     <div className="main-container" style={{ }}>
//              <div className="logo-container">
//                <img src={logoMain} alt="Dhanturi Group Logo" />
//              </div>
    
//              <div className="title-text">SHARAN`S INN</div>
//              {/* <div className="subtitle-text">GROUP</div> */}
    
//       <div className="cards-container">
//         {cardData.map((card, index) => (
//           <div className="cardss" key={index}>
//             <div className="image-container">
//               <img src={card.image} alt={`Hotel ${index + 1}`} />
//               <div className="location-overlay">{card.location}</div>
//             </div>
           

//             <div className="icon-column">
//               <div className="icon-row">
//                 <div className="circle-icon" title="Room">
//                   <FaBed />
//                 </div>
//                 <span className="icon-label">Room</span>
//                 <button className="book-now-btn">Book Now</button>
//               </div>
//               <div className="icon-row">
//                 <div className="circle-icon" title="Restaurant">
//                   <FaUtensils />
//                 </div>
//                 <span className="icon-label">Restaurant</span>
//                 <button className="book-now-btn">Book Now</button>
//               </div>
             
//               <div className="icon-row">
//                 <div className="circle-icon" title="Banquet Hall">
//                   <FaLandmark />
//                 </div>
//                 <span className="icon-label">Banquet Hall</span>
//                 <button className="book-now-btn">Book Now</button>
//               </div>
//             </div>

//             {/* <button className="card-button">View Details</button> */}
//           </div>
//         ))}
//       </div>

//       {/* STYLE */}
//       <style>{`
//         .main-container {
//           // background: radial-gradient(circle, #001a33, #000c1a);
//           background:white;
//           font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
//           color: #fff;
//           text-align: center;
//           padding: 20px;
//         }
           

//          .logo-container img {
//            max-width: 599px;
//            width: 114%;
//            height: 398px;
//          }

//         .title-text {
//           font-size: 80px;
//           font-weight: bold;
//           color: #e19c3a;
//           margin-top: -87px;
//         }

//         .subtitle-text {
//           font-size: 18px;
//           color: #f4c067;
//           margin-bottom: 30px;
//         }

//         .cards-container {
//           display: flex;
//           justify-content: center;
//           flex-wrap: wrap;
//           gap: 20px;
//           padding: 20px 0;
//         }

//         .cardss {
//           background: #fff;
//           border-radius: 20px;
//           width: 270px;
//           display: flex;
//           flex-direction: column;
//           align-items: center;
//           overflow: hidden;
//           padding: 20px 10px;
//           color: #000;
//           position: relative;
//         }

//         .image-container {
//           position: relative;
//           width: 100%;
//           height: 180px;
//         }

//         .image-container img {
//           width: 100%;
//           height: 100%;
//           object-fit: cover;
//           border-radius: 12px;
//         }

//         .location-overlay {
//           position: absolute;
//           bottom: 10px;
//           left: 50%;
//           transform: translateX(-50%);
//           background: rgba(0, 26, 51, 0.7);
//           color: #f4c067;
//           padding: 6px 12px;
//           border-radius: 10px;
//           font-size: 14px;
//           font-weight: bold;
//           z-index: 1;
//         }

//         .icon-column {
//           display: flex;
//           flex-direction: column;
//           gap: 10px;
//           margin-top: 15px;
//           width: 100%;
//         }

//         .icon-row {
//           display: flex;
//           align-items: center;
//           gap: 10px;
//           justify-content: space-between;
//           background: #f9f9f9;
//           padding: 8px 10px;
//           border-radius: 12px;
//         }

//         .circle-icon {
//           width: 40px;
//           height: 40px;
//           border-radius: 50%;
//           background-color: #001a33;
//           color: #f4c067;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           font-size: 18px;
//           cursor: pointer;
//         }

//         .icon-label {
//           flex-grow: 1;
//           text-align: left;
//           font-weight: 600;
//           color: #333;
//         }

//         .book-now-btn {
//           padding: 5px 10px;
//           background-color:#ffbb60;
//           color: white;
//           border: none;
//           border-radius: 8px;
//           font-size: 12px;
//           cursor: pointer;
//         }

//         .book-now-btn:hover {
//           background-color: #000;
//         }

//         .card-button {
//           margin-top: 15px;
//           padding: 8px 16px;
//           background-color: #001a33;
//           color: #f4c067;
//           border: none;
//           border-radius: 10px;
//           font-weight: bold;
//           cursor: pointer;
//         }

//         .card-button:hover {
//           background-color: #f4c067;
//           color: #001a33;
//         }

//         @media (max-width: 768px) {
//           .cardss {
//             width: 100%;
//           }

//           .title-text {
//             font-size: 24px;
//           }

//           .subtitle-text {
//             font-size: 16px;
//           }
//         }
//       `}</style>
//     </div>
//   );
// };

// export default HotelFacilities;



import React from "react";
import { FaBed, FaUtensils, FaLandmark } from "react-icons/fa";
import logoMain from '../img/aaaservices/S LOGO PNG-02-01.png';
// ✅ Import all 4 images
import hotelRoomImg1 from "../img/aaaservices/hotelw.jpg";
import hotelRoomImg2 from "../img/banner/hotel.webp";
import hotelRoomImg3 from "../img/banner/hotel1.jpg";
import hotelRoomImg4 from "../img/banner/hotel3.jpg";
// ✅ Import background image
import bannerImg from "../img/banner/WEBSITE_BANNER_V2-01[1].jpg";

const cardData = [
  {
    image: hotelRoomImg1,
    location: "Medchal",
  },
  {
    image: hotelRoomImg2,
    location: "Bongloor",
  },
  {
    image: hotelRoomImg3,
    location: "Pragati Nagar,",
  },
  {
    image: hotelRoomImg4,
    location: "Kukatpally",
  },
];

const HotelFacilities = () => {
  return (
    <section id="what-we-do" style={{}}>
    <div className="main-container">
      <div className="logo-container">
        <img src={logoMain} alt="Dhanturi Group Logo" />
      </div>

      <div className="title-text">SHARAN`S INN</div>
      {/* <div className="subtitle-text">GROUP</div> */}

      <div className="cards-container">
        {cardData.map((card, index) => (
          <div className="cardss" key={index}>
            <div className="image-container">
              <img src={card.image} alt={`Hotel ${index + 1}`} />
              <div className="location-overlay">{card.location}</div>
            </div>

            <div className="icon-column">
              <div className="icon-row">
                <div className="circle-icon" title="Room">
                  <FaBed />
                </div>
                <span className="icon-label">Room</span>
                <a href="https://maamaas.com/" target="_blank" rel="noopener noreferrer" className="book-now-btn">
  Book Now
</a>


              </div>
              <div className="icon-row">
                <div className="circle-icon" title="Restaurant">
                  <FaUtensils />
                </div>
                <span className="icon-label">Restaurant</span>
                <button className="book-now-btn">Book Now</button>
              </div>
              <div className="icon-row">
                <div className="circle-icon" title="Banquet Hall">
                  <FaLandmark />
                </div>
                <span className="icon-label">Banquet Hall</span>
                <button className="book-now-btn">Book Now</button>
              </div>
            </div>

            {/* <button className="card-button">View Details</button> */}
          </div>
        ))}
      </div>

      {/* STYLE */}
      <style>{`
        .main-container {
          background: url(${bannerImg}) no-repeat center top;
          background-size: cover;
          font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
          color: #fff;
          text-align: center;
          padding: 20px;
        }

        .logo-container img {
          max-width: 599px;
          width: 114%;
          height: 398px;
        }

        .title-text {
          font-size: 80px;
          font-weight: bold;
          color: #e19c3a;
          margin-top: -87px;
          font-family: Raqupine Regular;
        }

        .subtitle-text {
          font-size: 18px;
          color: #f4c067;
          margin-bottom: 30px;
        }

        .cards-container {
          display: flex;
          justify-content: center;
          flex-wrap: wrap;
          gap: 20px;
          padding: 20px 0;
        }

        .cardss {
          background: #fff;
          border-radius: 20px;
          width: 270px;
          display: flex;
          flex-direction: column;
          align-items: center;
          overflow: hidden;
          padding: 20px 10px;
          color: #000;
          position: relative;
        }

        .image-container {
          position: relative;
          width: 100%;
          height: 180px;
        }

        .image-container img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 12px;
        }

        .location-overlay {
          position: absolute;
          bottom: 128px;
          left: 50%;
          transform: translateX(-50%);
           background: white;
          color: black;
          padding: 6px 12px;
          border-radius: 10px;
          font-size: 15px;
          font-weight: bold;
          z-index: 1;
        }

        .icon-column {
          display: flex;
          flex-direction: column;
          gap: 10px;
          margin-top: 15px;
          width: 100%;
        }

        .icon-row {
          display: flex;
          align-items: center;
          gap: 10px;
          justify-content: space-between;
          background: #b00001;
          padding: 8px 10px;
          border-radius: 12px;
        }

        .circle-icon {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          background-color: #001a33;
          color: #f4c067;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 18px;
          cursor: pointer;
        }

        .icon-label {
          flex-grow: 1;
          text-align: left;
          font-weight: 600;
          color: #fff;
        }

        .book-now-btn {
          padding: 5px 10px;
          background-color:#ffbb60;
          color: white;
          border: none;
          border-radius: 8px;
          font-size: 12px;
          cursor: pointer;
        }

        .book-now-btn:hover {
          background-color: #000;
        }

        .card-button {
          margin-top: 15px;
          padding: 8px 16px;
          background-color: #001a33;
          color: #f4c067;
          border: none;
          border-radius: 10px;
          font-weight: bold;
          cursor: pointer;
        }

        .card-button:hover {
          background-color: #f4c067;
          color: #001a33;
        }

        @media (max-width: 768px) {
          .cardss {
            width: 100%;
          }

          .title-text {
            font-size: 24px;
          }

          .subtitle-text {
            font-size: 16px;
          }
        }
      `}</style>
    </div>
    </section>
  );
};

export default HotelFacilities;

